import Component from '@glimmer/component';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { tracked } from '@glimmer/tracking';
import eq from 'madow-tech/helpers/eq';

interface SpaceButtonSignature {
  Args: {
    variant?: 'v1' | 'v2' | 'v3' | 'v4';
    type?: string;
    disabled?: boolean;
    label?: string;
    onClick?: (event: Event) => void;
  };
}

export default class SpaceButton extends Component<SpaceButtonSignature> {
  @tracked isFocused = false;

  get buttonClass() {
    const variant = this.args.variant || 'v1';
    return `sci-button ${variant}`;
  }

  @action
  handleClick(event: Event) {
    if (this.args.onClick) {
      this.args.onClick(event);
    }
  }

  @action
  handleFocus() {
    this.isFocused = true;
  }

  get isV4orV5() {
    return this.args.variant === 'v4' || this.args.variant === 'v5';
  }

  <template>
    {{#if this.isV4orV5}}
      <div class="sci-button-wrapper" ...attributes>
        <div class="sci-button-container">
          <button
            type={{@type}}
            class="sci-button {{@variant}} inline-block text-center no-underline"
            href="#"
            {{on "click" this.handleClick}}
            {{on "focus" this.handleFocus}}
          >
            {{@label}}
            {{#if (has-block)}}
              {{yield}}
            {{/if}}
          </button>
        </div>
      </div>
    {{else}}
      <button
        class={{this.buttonClass}}
        type={{@type}}
        disabled={{@disabled}}
        {{on "click" this.handleClick}}
        ...attributes
      >
        {{@label}}
        {{#if (has-block)}}
          {{yield}}
        {{/if}}
      </button>
    {{/if}}
  </template>
}
